/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationStatus = exports.PricingTypeEnumType = exports.PollLayoutType = exports.PollLayoutDirection = exports.PluginContainerDataAlignment = exports.Placement = exports.Orientation = exports.OrderTag = exports.OrderStatus = exports.OrderFieldset = exports.OrderActionEnumAction = exports.NodeType = exports.Namespace = exports.MapType = exports.LocationType = exports.ListTicketsRequestState = exports.LineStyle = exports.LayoutType = exports.InputControlType = exports.InitialExpandedItems = exports.ImageStylesPosition = exports.GuestRegistrationReportType = exports.GIFType = exports.FontType = exports.FeeType = exports.FeeName = exports.EventType = exports.EventStatus = exports.EventFieldset = exports.DividerDataWidth = exports.DividerDataAlignment = exports.DeleteStatus = exports.DecorationType = exports.Crop = exports.ConferenceType = exports.CollapsibleListDataDirection = exports.CheckoutType = exports.ChannelType = exports.CategoryStateState = exports.CategoryFieldset = exports.CardStylesType = exports.CardStylesLayout = exports.CardStylesAlignment = exports.ButtonDataType = exports.BadgeTypeType = exports.BackgroundType = exports.AssetState = exports.AspectRatio = exports.AppType = exports.AppState = void 0;
exports.WidthType = exports.VoteRole = exports.VisitorType = exports.ViewRole = exports.ViewMode = exports.VerticalAlignment = exports.ValueType = exports.V1NullValue = exports.TicketSaleStatus = exports.TicketFieldset = exports.TicketDefinitionStateEnumState = exports.TicketDefinitionFieldset = exports.ThumbnailsAlignment = exports.TextAlignment = exports.TaxType = exports.Target = exports.SubdivisionType = exports.StylesPosition = exports.Status = exports.Source = exports.SortOrder = exports.SiteSettingsFieldset = exports.SiteCreatedContext = exports.Segment = exports.ScheduledActionEnumAction = exports.ScheduledActionAction = exports.RsvpStatusOptions = exports.Resizing = exports.ReservationStatus = exports.RequestedFields = exports.Relation = void 0;
var AppState;
(function (AppState) {
    AppState["ENABLED"] = "ENABLED";
    AppState["DISABLED"] = "DISABLED";
})(AppState = exports.AppState || (exports.AppState = {}));
var AppType;
(function (AppType) {
    AppType["PRODUCT"] = "PRODUCT";
    AppType["EVENT"] = "EVENT";
    AppType["BOOKING"] = "BOOKING";
})(AppType = exports.AppType || (exports.AppType = {}));
var AspectRatio;
(function (AspectRatio) {
    AspectRatio["SQUARE"] = "SQUARE";
    AspectRatio["RECTANGLE"] = "RECTANGLE";
})(AspectRatio = exports.AspectRatio || (exports.AspectRatio = {}));
var AssetState;
(function (AssetState) {
    AssetState["UNKNOWN"] = "UNKNOWN";
    AssetState["ENABLED"] = "ENABLED";
    AssetState["DISABLED"] = "DISABLED";
    AssetState["PENDING"] = "PENDING";
    AssetState["DEMO"] = "DEMO";
})(AssetState = exports.AssetState || (exports.AssetState = {}));
var BackgroundType;
(function (BackgroundType) {
    BackgroundType["COLOR"] = "COLOR";
    BackgroundType["IMAGE"] = "IMAGE";
    BackgroundType["GRADIENT"] = "GRADIENT";
})(BackgroundType = exports.BackgroundType || (exports.BackgroundType = {}));
var BadgeTypeType;
(function (BadgeTypeType) {
    BadgeTypeType["UNKNOWN_BADGE_TYPE"] = "UNKNOWN_BADGE_TYPE";
    BadgeTypeType["FIRST_PRIORITY"] = "FIRST_PRIORITY";
    BadgeTypeType["SECOND_PRIORITY"] = "SECOND_PRIORITY";
    BadgeTypeType["THIRD_PRIORITY"] = "THIRD_PRIORITY";
})(BadgeTypeType = exports.BadgeTypeType || (exports.BadgeTypeType = {}));
var ButtonDataType;
(function (ButtonDataType) {
    ButtonDataType["LINK"] = "LINK";
    ButtonDataType["ACTION"] = "ACTION";
})(ButtonDataType = exports.ButtonDataType || (exports.ButtonDataType = {}));
var CardStylesAlignment;
(function (CardStylesAlignment) {
    CardStylesAlignment["START"] = "START";
    CardStylesAlignment["CENTER"] = "CENTER";
    CardStylesAlignment["END"] = "END";
})(CardStylesAlignment = exports.CardStylesAlignment || (exports.CardStylesAlignment = {}));
var CardStylesLayout;
(function (CardStylesLayout) {
    CardStylesLayout["STACKED"] = "STACKED";
    CardStylesLayout["SIDE_BY_SIDE"] = "SIDE_BY_SIDE";
})(CardStylesLayout = exports.CardStylesLayout || (exports.CardStylesLayout = {}));
var CardStylesType;
(function (CardStylesType) {
    CardStylesType["CONTAINED"] = "CONTAINED";
    CardStylesType["FRAMELESS"] = "FRAMELESS";
})(CardStylesType = exports.CardStylesType || (exports.CardStylesType = {}));
var CategoryFieldset;
(function (CategoryFieldset) {
    CategoryFieldset["COUNTS"] = "COUNTS";
})(CategoryFieldset = exports.CategoryFieldset || (exports.CategoryFieldset = {}));
var CategoryStateState;
(function (CategoryStateState) {
    CategoryStateState["MANUAL"] = "MANUAL";
    CategoryStateState["AUTO"] = "AUTO";
    CategoryStateState["RECURRING_EVENT"] = "RECURRING_EVENT";
    CategoryStateState["HIDDEN"] = "HIDDEN";
    CategoryStateState["COMPONENT"] = "COMPONENT";
})(CategoryStateState = exports.CategoryStateState || (exports.CategoryStateState = {}));
var ChannelType;
(function (ChannelType) {
    ChannelType["ONLINE"] = "ONLINE";
    ChannelType["OFFLINE_POS"] = "OFFLINE_POS";
})(ChannelType = exports.ChannelType || (exports.ChannelType = {}));
var CheckoutType;
(function (CheckoutType) {
    CheckoutType["UNKNOWN_CHECKOUT_TYPE"] = "UNKNOWN_CHECKOUT_TYPE";
    CheckoutType["EVENTS_APP"] = "EVENTS_APP";
    CheckoutType["ECOMM_PLATFORM"] = "ECOMM_PLATFORM";
})(CheckoutType = exports.CheckoutType || (exports.CheckoutType = {}));
var CollapsibleListDataDirection;
(function (CollapsibleListDataDirection) {
    CollapsibleListDataDirection["LTR"] = "LTR";
    CollapsibleListDataDirection["RTL"] = "RTL";
})(CollapsibleListDataDirection = exports.CollapsibleListDataDirection || (exports.CollapsibleListDataDirection = {}));
var ConferenceType;
(function (ConferenceType) {
    ConferenceType["MEETING"] = "MEETING";
    ConferenceType["WEBINAR"] = "WEBINAR";
})(ConferenceType = exports.ConferenceType || (exports.ConferenceType = {}));
var Crop;
(function (Crop) {
    Crop["FILL"] = "FILL";
    Crop["FIT"] = "FIT";
})(Crop = exports.Crop || (exports.Crop = {}));
var DecorationType;
(function (DecorationType) {
    DecorationType["BOLD"] = "BOLD";
    DecorationType["ITALIC"] = "ITALIC";
    DecorationType["UNDERLINE"] = "UNDERLINE";
    DecorationType["SPOILER"] = "SPOILER";
    DecorationType["ANCHOR"] = "ANCHOR";
    DecorationType["MENTION"] = "MENTION";
    DecorationType["LINK"] = "LINK";
    DecorationType["COLOR"] = "COLOR";
    DecorationType["FONT_SIZE"] = "FONT_SIZE";
    DecorationType["EXTERNAL"] = "EXTERNAL";
    DecorationType["STRIKETHROUGH"] = "STRIKETHROUGH";
    DecorationType["SUPERSCRIPT"] = "SUPERSCRIPT";
    DecorationType["SUBSCRIPT"] = "SUBSCRIPT";
})(DecorationType = exports.DecorationType || (exports.DecorationType = {}));
var DeleteStatus;
(function (DeleteStatus) {
    DeleteStatus["UNKNOWN"] = "UNKNOWN";
    DeleteStatus["TRASH"] = "TRASH";
    DeleteStatus["DELETED"] = "DELETED";
    DeleteStatus["PENDING_PURGE"] = "PENDING_PURGE";
    DeleteStatus["PURGED_EXTERNALLY"] = "PURGED_EXTERNALLY";
})(DeleteStatus = exports.DeleteStatus || (exports.DeleteStatus = {}));
var DividerDataAlignment;
(function (DividerDataAlignment) {
    DividerDataAlignment["CENTER"] = "CENTER";
    DividerDataAlignment["LEFT"] = "LEFT";
    DividerDataAlignment["RIGHT"] = "RIGHT";
})(DividerDataAlignment = exports.DividerDataAlignment || (exports.DividerDataAlignment = {}));
var DividerDataWidth;
(function (DividerDataWidth) {
    DividerDataWidth["LARGE"] = "LARGE";
    DividerDataWidth["MEDIUM"] = "MEDIUM";
    DividerDataWidth["SMALL"] = "SMALL";
})(DividerDataWidth = exports.DividerDataWidth || (exports.DividerDataWidth = {}));
var EventFieldset;
(function (EventFieldset) {
    EventFieldset["FULL"] = "FULL";
    EventFieldset["DETAILS"] = "DETAILS";
    EventFieldset["TEXTS"] = "TEXTS";
    EventFieldset["REGISTRATION"] = "REGISTRATION";
    EventFieldset["URLS"] = "URLS";
    EventFieldset["FORM"] = "FORM";
    EventFieldset["DASHBOARD"] = "DASHBOARD";
    EventFieldset["FEED"] = "FEED";
    EventFieldset["ONLINE_CONFERENCING_SESSION"] = "ONLINE_CONFERENCING_SESSION";
    EventFieldset["SEO_SETTINGS"] = "SEO_SETTINGS";
    EventFieldset["AGENDA"] = "AGENDA";
    EventFieldset["CATEGORIES"] = "CATEGORIES";
    EventFieldset["CUSTOMIZABLE_TICKETS"] = "CUSTOMIZABLE_TICKETS";
    EventFieldset["BADGES"] = "BADGES";
})(EventFieldset = exports.EventFieldset || (exports.EventFieldset = {}));
var EventStatus;
(function (EventStatus) {
    EventStatus["SCHEDULED"] = "SCHEDULED";
    EventStatus["STARTED"] = "STARTED";
    EventStatus["ENDED"] = "ENDED";
    EventStatus["CANCELED"] = "CANCELED";
    EventStatus["DRAFT"] = "DRAFT";
})(EventStatus = exports.EventStatus || (exports.EventStatus = {}));
var EventType;
(function (EventType) {
    EventType["NA_EVENT_TYPE"] = "NA_EVENT_TYPE";
    EventType["RSVP"] = "RSVP";
    EventType["TICKETS"] = "TICKETS";
    EventType["EXTERNAL"] = "EXTERNAL";
    EventType["NO_REGISTRATION"] = "NO_REGISTRATION";
    EventType["RSVP_AND_TICKETS"] = "RSVP_AND_TICKETS";
})(EventType = exports.EventType || (exports.EventType = {}));
var FeeName;
(function (FeeName) {
    FeeName["WIX_FEE"] = "WIX_FEE";
})(FeeName = exports.FeeName || (exports.FeeName = {}));
var FeeType;
(function (FeeType) {
    FeeType["FEE_ADDED"] = "FEE_ADDED";
    FeeType["FEE_INCLUDED"] = "FEE_INCLUDED";
    FeeType["FEE_ADDED_AT_CHECKOUT"] = "FEE_ADDED_AT_CHECKOUT";
})(FeeType = exports.FeeType || (exports.FeeType = {}));
var FontType;
(function (FontType) {
    FontType["PX"] = "PX";
    FontType["EM"] = "EM";
})(FontType = exports.FontType || (exports.FontType = {}));
var GIFType;
(function (GIFType) {
    GIFType["NORMAL"] = "NORMAL";
    GIFType["STICKER"] = "STICKER";
})(GIFType = exports.GIFType || (exports.GIFType = {}));
var GuestRegistrationReportType;
(function (GuestRegistrationReportType) {
    GuestRegistrationReportType["INSTANT_UPDATE"] = "INSTANT_UPDATE";
    GuestRegistrationReportType["DAILY_SUMMARY"] = "DAILY_SUMMARY";
})(GuestRegistrationReportType = exports.GuestRegistrationReportType || (exports.GuestRegistrationReportType = {}));
var ImageStylesPosition;
(function (ImageStylesPosition) {
    ImageStylesPosition["START"] = "START";
    ImageStylesPosition["END"] = "END";
    ImageStylesPosition["TOP"] = "TOP";
})(ImageStylesPosition = exports.ImageStylesPosition || (exports.ImageStylesPosition = {}));
var InitialExpandedItems;
(function (InitialExpandedItems) {
    InitialExpandedItems["FIRST"] = "FIRST";
    InitialExpandedItems["ALL"] = "ALL";
    InitialExpandedItems["NONE"] = "NONE";
})(InitialExpandedItems = exports.InitialExpandedItems || (exports.InitialExpandedItems = {}));
var InputControlType;
(function (InputControlType) {
    InputControlType["INPUT"] = "INPUT";
    InputControlType["TEXTAREA"] = "TEXTAREA";
    InputControlType["DROPDOWN"] = "DROPDOWN";
    InputControlType["RADIO"] = "RADIO";
    InputControlType["CHECKBOX"] = "CHECKBOX";
    InputControlType["NAME"] = "NAME";
    InputControlType["GUEST_CONTROL"] = "GUEST_CONTROL";
    InputControlType["ADDRESS_SHORT"] = "ADDRESS_SHORT";
    InputControlType["ADDRESS_FULL"] = "ADDRESS_FULL";
    InputControlType["DATE"] = "DATE";
})(InputControlType = exports.InputControlType || (exports.InputControlType = {}));
var LayoutType;
(function (LayoutType) {
    LayoutType["COLLAGE"] = "COLLAGE";
    LayoutType["MASONRY"] = "MASONRY";
    LayoutType["GRID"] = "GRID";
    LayoutType["THUMBNAIL"] = "THUMBNAIL";
    LayoutType["SLIDER"] = "SLIDER";
    LayoutType["SLIDESHOW"] = "SLIDESHOW";
    LayoutType["PANORAMA"] = "PANORAMA";
    LayoutType["COLUMN"] = "COLUMN";
    LayoutType["MAGIC"] = "MAGIC";
    LayoutType["FULLSIZE"] = "FULLSIZE";
})(LayoutType = exports.LayoutType || (exports.LayoutType = {}));
var LineStyle;
(function (LineStyle) {
    LineStyle["SINGLE"] = "SINGLE";
    LineStyle["DOUBLE"] = "DOUBLE";
    LineStyle["DASHED"] = "DASHED";
    LineStyle["DOTTED"] = "DOTTED";
})(LineStyle = exports.LineStyle || (exports.LineStyle = {}));
var ListTicketsRequestState;
(function (ListTicketsRequestState) {
    ListTicketsRequestState["ORDER_ARCHIVED"] = "ORDER_ARCHIVED";
    ListTicketsRequestState["ORDER_ACTIVE"] = "ORDER_ACTIVE";
    ListTicketsRequestState["TICKET_ARCHIVED"] = "TICKET_ARCHIVED";
    ListTicketsRequestState["TICKET_ACTIVE"] = "TICKET_ACTIVE";
    ListTicketsRequestState["CHECKED_IN"] = "CHECKED_IN";
    ListTicketsRequestState["NON_CHECKED_IN"] = "NON_CHECKED_IN";
    ListTicketsRequestState["FREE"] = "FREE";
    ListTicketsRequestState["PAID"] = "PAID";
    ListTicketsRequestState["MEMBER"] = "MEMBER";
})(ListTicketsRequestState = exports.ListTicketsRequestState || (exports.ListTicketsRequestState = {}));
var LocationType;
(function (LocationType) {
    LocationType["VENUE"] = "VENUE";
    LocationType["ONLINE"] = "ONLINE";
})(LocationType = exports.LocationType || (exports.LocationType = {}));
var MapType;
(function (MapType) {
    MapType["ROADMAP"] = "ROADMAP";
    MapType["SATELITE"] = "SATELITE";
    MapType["HYBRID"] = "HYBRID";
    MapType["TERRAIN"] = "TERRAIN";
})(MapType = exports.MapType || (exports.MapType = {}));
var Namespace;
(function (Namespace) {
    Namespace["UNKNOWN_NAMESPACE"] = "UNKNOWN_NAMESPACE";
    Namespace["WIX"] = "WIX";
    Namespace["SHOUT_OUT"] = "SHOUT_OUT";
    Namespace["ALBUMS"] = "ALBUMS";
    Namespace["WIX_STORES_TEST_DRIVE"] = "WIX_STORES_TEST_DRIVE";
    Namespace["HOTELS"] = "HOTELS";
    Namespace["CLUBS"] = "CLUBS";
    Namespace["ONBOARDING_DRAFT"] = "ONBOARDING_DRAFT";
    Namespace["DEV_SITE"] = "DEV_SITE";
    Namespace["LOGOS"] = "LOGOS";
    Namespace["VIDEO_MAKER"] = "VIDEO_MAKER";
    Namespace["PARTNER_DASHBOARD"] = "PARTNER_DASHBOARD";
    Namespace["DEV_CENTER_COMPANY"] = "DEV_CENTER_COMPANY";
    Namespace["HTML_DRAFT"] = "HTML_DRAFT";
    Namespace["SITELESS_BUSINESS"] = "SITELESS_BUSINESS";
    Namespace["CREATOR_ECONOMY"] = "CREATOR_ECONOMY";
    Namespace["DASHBOARD_FIRST"] = "DASHBOARD_FIRST";
    Namespace["ANYWHERE"] = "ANYWHERE";
    Namespace["HEADLESS"] = "HEADLESS";
    Namespace["ACCOUNT_MASTER_CMS"] = "ACCOUNT_MASTER_CMS";
    Namespace["RISE"] = "RISE";
    Namespace["BRANDED_FIRST"] = "BRANDED_FIRST";
    Namespace["NOWNIA"] = "NOWNIA";
    Namespace["UGC_TEMPLATE"] = "UGC_TEMPLATE";
    Namespace["CODUX"] = "CODUX";
    Namespace["MEDIA_DESIGN_CREATOR"] = "MEDIA_DESIGN_CREATOR";
    Namespace["SHARED_BLOG_ENTERPRISE"] = "SHARED_BLOG_ENTERPRISE";
    Namespace["STANDALONE_FORMS"] = "STANDALONE_FORMS";
    Namespace["STANDALONE_EVENTS"] = "STANDALONE_EVENTS";
    Namespace["MIMIR"] = "MIMIR";
    Namespace["TWINS"] = "TWINS";
    Namespace["NANO"] = "NANO";
})(Namespace = exports.Namespace || (exports.Namespace = {}));
var NodeType;
(function (NodeType) {
    NodeType["PARAGRAPH"] = "PARAGRAPH";
    NodeType["TEXT"] = "TEXT";
    NodeType["HEADING"] = "HEADING";
    NodeType["BULLETED_LIST"] = "BULLETED_LIST";
    NodeType["ORDERED_LIST"] = "ORDERED_LIST";
    NodeType["LIST_ITEM"] = "LIST_ITEM";
    NodeType["BLOCKQUOTE"] = "BLOCKQUOTE";
    NodeType["CODE_BLOCK"] = "CODE_BLOCK";
    NodeType["VIDEO"] = "VIDEO";
    NodeType["DIVIDER"] = "DIVIDER";
    NodeType["FILE"] = "FILE";
    NodeType["GALLERY"] = "GALLERY";
    NodeType["GIF"] = "GIF";
    NodeType["HTML"] = "HTML";
    NodeType["IMAGE"] = "IMAGE";
    NodeType["LINK_PREVIEW"] = "LINK_PREVIEW";
    NodeType["MAP"] = "MAP";
    NodeType["POLL"] = "POLL";
    NodeType["APP_EMBED"] = "APP_EMBED";
    NodeType["BUTTON"] = "BUTTON";
    NodeType["COLLAPSIBLE_LIST"] = "COLLAPSIBLE_LIST";
    NodeType["TABLE"] = "TABLE";
    NodeType["EMBED"] = "EMBED";
    NodeType["COLLAPSIBLE_ITEM"] = "COLLAPSIBLE_ITEM";
    NodeType["COLLAPSIBLE_ITEM_TITLE"] = "COLLAPSIBLE_ITEM_TITLE";
    NodeType["COLLAPSIBLE_ITEM_BODY"] = "COLLAPSIBLE_ITEM_BODY";
    NodeType["TABLE_CELL"] = "TABLE_CELL";
    NodeType["TABLE_ROW"] = "TABLE_ROW";
    NodeType["EXTERNAL"] = "EXTERNAL";
    NodeType["AUDIO"] = "AUDIO";
    NodeType["CAPTION"] = "CAPTION";
    NodeType["LAYOUT"] = "LAYOUT";
    NodeType["LAYOUT_CELL"] = "LAYOUT_CELL";
})(NodeType = exports.NodeType || (exports.NodeType = {}));
var OrderActionEnumAction;
(function (OrderActionEnumAction) {
    OrderActionEnumAction["ARCHIVE"] = "ARCHIVE";
    OrderActionEnumAction["UNARCHIVE"] = "UNARCHIVE";
    OrderActionEnumAction["CONFIRM"] = "CONFIRM";
    OrderActionEnumAction["CAPTURE"] = "CAPTURE";
    OrderActionEnumAction["VOID"] = "VOID";
})(OrderActionEnumAction = exports.OrderActionEnumAction || (exports.OrderActionEnumAction = {}));
var OrderFieldset;
(function (OrderFieldset) {
    OrderFieldset["TICKETS"] = "TICKETS";
    OrderFieldset["DETAILS"] = "DETAILS";
    OrderFieldset["FORM"] = "FORM";
    OrderFieldset["INVOICE"] = "INVOICE";
})(OrderFieldset = exports.OrderFieldset || (exports.OrderFieldset = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["NA_ORDER_STATUS"] = "NA_ORDER_STATUS";
    OrderStatus["FREE"] = "FREE";
    OrderStatus["PENDING"] = "PENDING";
    OrderStatus["PAID"] = "PAID";
    OrderStatus["OFFLINE_PENDING"] = "OFFLINE_PENDING";
    OrderStatus["INITIATED"] = "INITIATED";
    OrderStatus["CANCELED"] = "CANCELED";
    OrderStatus["DECLINED"] = "DECLINED";
    OrderStatus["AUTHORIZED"] = "AUTHORIZED";
    OrderStatus["VOIDED"] = "VOIDED";
    OrderStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var OrderTag;
(function (OrderTag) {
    OrderTag["CONFIRMED"] = "CONFIRMED";
    OrderTag["UNCONFIRMED"] = "UNCONFIRMED";
    OrderTag["MEMBER"] = "MEMBER";
    OrderTag["ARCHIVED"] = "ARCHIVED";
    OrderTag["NON_ARCHIVED"] = "NON_ARCHIVED";
    OrderTag["FULLY_CHECKED_IN"] = "FULLY_CHECKED_IN";
    OrderTag["NOT_FULLY_CHECKED_IN"] = "NOT_FULLY_CHECKED_IN";
})(OrderTag = exports.OrderTag || (exports.OrderTag = {}));
var Orientation;
(function (Orientation) {
    Orientation["ROWS"] = "ROWS";
    Orientation["COLUMNS"] = "COLUMNS";
})(Orientation = exports.Orientation || (exports.Orientation = {}));
var Placement;
(function (Placement) {
    Placement["IMAGE"] = "IMAGE";
    Placement["PRODUCT_INFO"] = "PRODUCT_INFO";
})(Placement = exports.Placement || (exports.Placement = {}));
var PluginContainerDataAlignment;
(function (PluginContainerDataAlignment) {
    PluginContainerDataAlignment["CENTER"] = "CENTER";
    PluginContainerDataAlignment["LEFT"] = "LEFT";
    PluginContainerDataAlignment["RIGHT"] = "RIGHT";
})(PluginContainerDataAlignment = exports.PluginContainerDataAlignment || (exports.PluginContainerDataAlignment = {}));
var PollLayoutDirection;
(function (PollLayoutDirection) {
    PollLayoutDirection["LTR"] = "LTR";
    PollLayoutDirection["RTL"] = "RTL";
})(PollLayoutDirection = exports.PollLayoutDirection || (exports.PollLayoutDirection = {}));
var PollLayoutType;
(function (PollLayoutType) {
    PollLayoutType["LIST"] = "LIST";
    PollLayoutType["GRID"] = "GRID";
})(PollLayoutType = exports.PollLayoutType || (exports.PollLayoutType = {}));
var PricingTypeEnumType;
(function (PricingTypeEnumType) {
    PricingTypeEnumType["STANDARD"] = "STANDARD";
    PricingTypeEnumType["DONATION"] = "DONATION";
})(PricingTypeEnumType = exports.PricingTypeEnumType || (exports.PricingTypeEnumType = {}));
var RegistrationStatus;
(function (RegistrationStatus) {
    RegistrationStatus["NA_REGISTRATION_STATUS"] = "NA_REGISTRATION_STATUS";
    RegistrationStatus["CLOSED"] = "CLOSED";
    RegistrationStatus["CLOSED_MANUALLY"] = "CLOSED_MANUALLY";
    RegistrationStatus["OPEN_RSVP"] = "OPEN_RSVP";
    RegistrationStatus["OPEN_RSVP_WAITLIST"] = "OPEN_RSVP_WAITLIST";
    RegistrationStatus["OPEN_TICKETS"] = "OPEN_TICKETS";
    RegistrationStatus["OPEN_EXTERNAL"] = "OPEN_EXTERNAL";
    RegistrationStatus["SCHEDULED_RSVP"] = "SCHEDULED_RSVP";
    RegistrationStatus["OPEN_RSVP_AND_TICKETS"] = "OPEN_RSVP_AND_TICKETS";
})(RegistrationStatus = exports.RegistrationStatus || (exports.RegistrationStatus = {}));
var Relation;
(function (Relation) {
    Relation["ATTENDING"] = "ATTENDING";
})(Relation = exports.Relation || (exports.Relation = {}));
var RequestedFields;
(function (RequestedFields) {
    RequestedFields["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
    RequestedFields["DELETED"] = "DELETED";
})(RequestedFields = exports.RequestedFields || (exports.RequestedFields = {}));
var ReservationStatus;
(function (ReservationStatus) {
    ReservationStatus["RESERVATION_PENDING"] = "RESERVATION_PENDING";
    ReservationStatus["RESERVATION_CONFIRMED"] = "RESERVATION_CONFIRMED";
    ReservationStatus["RESERVATION_CANCELED"] = "RESERVATION_CANCELED";
    ReservationStatus["RESERVATION_CANCELED_MANUALLY"] = "RESERVATION_CANCELED_MANUALLY";
    ReservationStatus["RESERVATION_EXPIRED"] = "RESERVATION_EXPIRED";
    ReservationStatus["RESERVATION_PREVIEW"] = "RESERVATION_PREVIEW";
})(ReservationStatus = exports.ReservationStatus || (exports.ReservationStatus = {}));
var Resizing;
(function (Resizing) {
    Resizing["FILL"] = "FILL";
    Resizing["FIT"] = "FIT";
})(Resizing = exports.Resizing || (exports.Resizing = {}));
var RsvpStatusOptions;
(function (RsvpStatusOptions) {
    RsvpStatusOptions["YES_ONLY"] = "YES_ONLY";
    RsvpStatusOptions["YES_AND_NO"] = "YES_AND_NO";
})(RsvpStatusOptions = exports.RsvpStatusOptions || (exports.RsvpStatusOptions = {}));
var ScheduledActionAction;
(function (ScheduledActionAction) {
    ScheduledActionAction["CAPTURE"] = "CAPTURE";
    ScheduledActionAction["VOID"] = "VOID";
})(ScheduledActionAction = exports.ScheduledActionAction || (exports.ScheduledActionAction = {}));
var ScheduledActionEnumAction;
(function (ScheduledActionEnumAction) {
    ScheduledActionEnumAction["UNKNOWN_ACTION"] = "UNKNOWN_ACTION";
    ScheduledActionEnumAction["CAPTURE"] = "CAPTURE";
    ScheduledActionEnumAction["VOID"] = "VOID";
})(ScheduledActionEnumAction = exports.ScheduledActionEnumAction || (exports.ScheduledActionEnumAction = {}));
var Segment;
(function (Segment) {
    Segment["PUBLISHED"] = "PUBLISHED";
    Segment["SAVED"] = "SAVED";
})(Segment = exports.Segment || (exports.Segment = {}));
var SiteCreatedContext;
(function (SiteCreatedContext) {
    SiteCreatedContext["OTHER"] = "OTHER";
    SiteCreatedContext["FROM_TEMPLATE"] = "FROM_TEMPLATE";
    SiteCreatedContext["DUPLICATE_BY_SITE_TRANSFER"] = "DUPLICATE_BY_SITE_TRANSFER";
    SiteCreatedContext["DUPLICATE"] = "DUPLICATE";
    SiteCreatedContext["OLD_SITE_TRANSFER"] = "OLD_SITE_TRANSFER";
    SiteCreatedContext["FLASH"] = "FLASH";
})(SiteCreatedContext = exports.SiteCreatedContext || (exports.SiteCreatedContext = {}));
var SiteSettingsFieldset;
(function (SiteSettingsFieldset) {
    SiteSettingsFieldset["EVENTS_SUMMARY"] = "EVENTS_SUMMARY";
})(SiteSettingsFieldset = exports.SiteSettingsFieldset || (exports.SiteSettingsFieldset = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var Source;
(function (Source) {
    Source["HTML"] = "HTML";
    Source["ADSENSE"] = "ADSENSE";
})(Source = exports.Source || (exports.Source = {}));
var Status;
(function (Status) {
    Status["ONE_TIME"] = "ONE_TIME";
    Status["RECURRING"] = "RECURRING";
    Status["RECURRING_NEXT"] = "RECURRING_NEXT";
    Status["RECURRING_LAST_ENDED"] = "RECURRING_LAST_ENDED";
    Status["RECURRING_LAST_CANCELED"] = "RECURRING_LAST_CANCELED";
})(Status = exports.Status || (exports.Status = {}));
var StylesPosition;
(function (StylesPosition) {
    StylesPosition["START"] = "START";
    StylesPosition["END"] = "END";
    StylesPosition["TOP"] = "TOP";
    StylesPosition["HIDDEN"] = "HIDDEN";
})(StylesPosition = exports.StylesPosition || (exports.StylesPosition = {}));
var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType = exports.SubdivisionType || (exports.SubdivisionType = {}));
var Target;
(function (Target) {
    Target["SELF"] = "SELF";
    Target["BLANK"] = "BLANK";
    Target["PARENT"] = "PARENT";
    Target["TOP"] = "TOP";
})(Target = exports.Target || (exports.Target = {}));
var TaxType;
(function (TaxType) {
    TaxType["INCLUDED"] = "INCLUDED";
    TaxType["ADDED"] = "ADDED";
    TaxType["ADDED_AT_CHECKOUT"] = "ADDED_AT_CHECKOUT";
})(TaxType = exports.TaxType || (exports.TaxType = {}));
var TextAlignment;
(function (TextAlignment) {
    TextAlignment["AUTO"] = "AUTO";
    TextAlignment["LEFT"] = "LEFT";
    TextAlignment["RIGHT"] = "RIGHT";
    TextAlignment["CENTER"] = "CENTER";
    TextAlignment["JUSTIFY"] = "JUSTIFY";
})(TextAlignment = exports.TextAlignment || (exports.TextAlignment = {}));
var ThumbnailsAlignment;
(function (ThumbnailsAlignment) {
    ThumbnailsAlignment["TOP"] = "TOP";
    ThumbnailsAlignment["RIGHT"] = "RIGHT";
    ThumbnailsAlignment["BOTTOM"] = "BOTTOM";
    ThumbnailsAlignment["LEFT"] = "LEFT";
    ThumbnailsAlignment["NONE"] = "NONE";
})(ThumbnailsAlignment = exports.ThumbnailsAlignment || (exports.ThumbnailsAlignment = {}));
var TicketDefinitionFieldset;
(function (TicketDefinitionFieldset) {
    TicketDefinitionFieldset["POLICY"] = "POLICY";
    TicketDefinitionFieldset["DASHBOARD"] = "DASHBOARD";
})(TicketDefinitionFieldset = exports.TicketDefinitionFieldset || (exports.TicketDefinitionFieldset = {}));
var TicketDefinitionStateEnumState;
(function (TicketDefinitionStateEnumState) {
    TicketDefinitionStateEnumState["INCLUDE_HIDDEN_NOT_ON_SALE"] = "INCLUDE_HIDDEN_NOT_ON_SALE";
})(TicketDefinitionStateEnumState = exports.TicketDefinitionStateEnumState || (exports.TicketDefinitionStateEnumState = {}));
var TicketFieldset;
(function (TicketFieldset) {
    TicketFieldset["GUEST_DETAILS"] = "GUEST_DETAILS";
    TicketFieldset["TICKET_DETAILS"] = "TICKET_DETAILS";
    TicketFieldset["GUEST_FORM"] = "GUEST_FORM";
})(TicketFieldset = exports.TicketFieldset || (exports.TicketFieldset = {}));
var TicketSaleStatus;
(function (TicketSaleStatus) {
    TicketSaleStatus["SALE_SCHEDULED"] = "SALE_SCHEDULED";
    TicketSaleStatus["SALE_STARTED"] = "SALE_STARTED";
    TicketSaleStatus["SALE_ENDED"] = "SALE_ENDED";
})(TicketSaleStatus = exports.TicketSaleStatus || (exports.TicketSaleStatus = {}));
var V1NullValue;
(function (V1NullValue) {
    V1NullValue["NULL_VALUE"] = "NULL_VALUE";
})(V1NullValue = exports.V1NullValue || (exports.V1NullValue = {}));
var ValueType;
(function (ValueType) {
    ValueType["TEXT"] = "TEXT";
    ValueType["NUMBER"] = "NUMBER";
    ValueType["TEXT_ARRAY"] = "TEXT_ARRAY";
    ValueType["DATE_TIME"] = "DATE_TIME";
    ValueType["ADDRESS"] = "ADDRESS";
})(ValueType = exports.ValueType || (exports.ValueType = {}));
var VerticalAlignment;
(function (VerticalAlignment) {
    VerticalAlignment["TOP"] = "TOP";
    VerticalAlignment["MIDDLE"] = "MIDDLE";
    VerticalAlignment["BOTTOM"] = "BOTTOM";
})(VerticalAlignment = exports.VerticalAlignment || (exports.VerticalAlignment = {}));
var ViewMode;
(function (ViewMode) {
    ViewMode["NONE"] = "NONE";
    ViewMode["FULL"] = "FULL";
    ViewMode["MINI"] = "MINI";
})(ViewMode = exports.ViewMode || (exports.ViewMode = {}));
var ViewRole;
(function (ViewRole) {
    ViewRole["CREATOR"] = "CREATOR";
    ViewRole["VOTERS"] = "VOTERS";
    ViewRole["EVERYONE"] = "EVERYONE";
})(ViewRole = exports.ViewRole || (exports.ViewRole = {}));
var VisitorType;
(function (VisitorType) {
    VisitorType["VISITOR"] = "VISITOR";
    VisitorType["MEMBER"] = "MEMBER";
    VisitorType["VISITOR_OR_MEMBER"] = "VISITOR_OR_MEMBER";
})(VisitorType = exports.VisitorType || (exports.VisitorType = {}));
var VoteRole;
(function (VoteRole) {
    VoteRole["SITE_MEMBERS"] = "SITE_MEMBERS";
    VoteRole["ALL"] = "ALL";
})(VoteRole = exports.VoteRole || (exports.VoteRole = {}));
var WidthType;
(function (WidthType) {
    WidthType["CONTENT"] = "CONTENT";
    WidthType["SMALL"] = "SMALL";
    WidthType["ORIGINAL"] = "ORIGINAL";
    WidthType["FULL_WIDTH"] = "FULL_WIDTH";
})(WidthType = exports.WidthType || (exports.WidthType = {}));
//# sourceMappingURL=types.js.map